import { OptimizerRunV2Mode, OptimizerRunV2Type } from '@generated/graphql';

/** Org-wide bulk rebalance is live-only; dry run stays on the per-portfolio widget (V1 parity). */
export const BULK_REBALANCE_ORG_MODE = OptimizerRunV2Mode.Live;

/**
 * Run types the bulk UI can start and filter by. `ALL_ELIGIBLE` is supported by HS but
 * withheld here until product discussion (scoped cash + mixed-batch UX).
 */
export const BULK_REBALANCE_START_RUN_TYPES: OptimizerRunV2Type[] = [
  OptimizerRunV2Type.Drift,
  OptimizerRunV2Type.Transfer,
];
